(function () {
  var STORAGE_KEY = 'eva-siket-wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isSaved(handle) {
    return getWishlist().some(function (item) { return item.handle === handle; });
  }

  function toggleWishlist(button) {
    var handle = button.getAttribute('data-product-handle');
    var title = button.getAttribute('data-product-title');
    var image = button.getAttribute('data-product-image');
    var price = button.getAttribute('data-product-price');
    var url = button.getAttribute('data-product-url');
    var list = getWishlist();
    var iconEl = button.querySelector('.eva-wishlist-icon');

    if (isSaved(handle)) {
      list = list.filter(function (item) { return item.handle !== handle; });
      button.classList.remove('is-saved');
      button.setAttribute('aria-pressed', 'false');
      if (iconEl) iconEl.textContent = '♡';
    } else {
      list.push({ handle: handle, title: title, image: image, price: price, url: url });
      button.classList.add('is-saved');
      button.setAttribute('aria-pressed', 'true');
      if (iconEl) iconEl.textContent = '♥';
    }
    saveWishlist(list);
    updateWishlistCount();
  }

  function updateWishlistCount() {
    var countEls = document.querySelectorAll('.eva-wishlist-count');
    var count = getWishlist().length;
    countEls.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  function renderWishlistPage() {
    var container = document.querySelector('[data-wishlist-container]');
    if (!container) return;
    var list = getWishlist();
    if (list.length === 0) {
      container.innerHTML = '<p class="eva-wishlist-empty">Your saved pieces will appear here. Browse the collection and tap the heart on any piece you love.</p>';
      return;
    }
    container.innerHTML = list.map(function (item) {
      return '<a href="' + item.url + '" class="eva-wishlist-item">' +
        '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' +
        '<p class="eva-wishlist-item__title">' + item.title + '</p>' +
        '<p class="eva-wishlist-item__price">' + item.price + '</p>' +
        '</a>';
    }).join('');
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.eva-wishlist-toggle').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var iconEl = button.querySelector('.eva-wishlist-icon');
      if (isSaved(handle)) {
        button.classList.add('is-saved');
        button.setAttribute('aria-pressed', 'true');
        if (iconEl) iconEl.textContent = '♥';
      }
      button.addEventListener('click', function () { toggleWishlist(button); });
    });
    updateWishlistCount();
    renderWishlistPage();
  });
})();
